import React from 'react';
import './Homepage.css';
import profileImage from './assets/marygrace.JPG'; // Replace with your actual image path

function Homepage() {
  return (
    <section id="home" className="hero-section">
      <div className="hero-left">
        <img src={profileImage} alt="Mary Grace" className="hero-image" />
      </div>
      <div className="hero-right">
        <h1><span>EMGEENEER</span></h1>
        <p>Aspiring Web Developer & Designer</p>
        <p>"I may be new to the industry, but I bring fresh perspective and strong determination. I'm here to learn, adapt, and make an impact."</p>
        <a href="#about" className="about-button">About Me</a>
      </div>
    </section>
  );
}

export default Homepage;
